import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { formatCurrency } from '../lib/util';
import { Button, TextField, MaskInput } from '../lib/common';
import DeleteButton from './delete-button';
import { Box } from '@mui/material';
import { colors } from '../lib/styles';

const styles = {
  columnHeader: {
    fontWeight: 'bold',
    backgroundColor: '#fff',
    color: colors.black,
    padding: '8px',
    borderRadius: '4px',
    marginBottom: '10px',
  },
  addButton: {
    marginTop: '15px',
    marginBottom: '15px',
  },
  totalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '20px',
  },
  totalLabel: {
    fontWeight: 'bold',
    color: colors.black,
    fontSize: '1.1rem',
  },
  totalValue: {
    fontWeight: 'bold',
    color: colors.black,
    fontSize: '1.1rem',
  },
};

const ClientAssetForm = (props) => {
  const { updateAssets, asset, updateList } = props;
  const [notes, setNotes] = useState(asset.notes);
  const [value, setValue] = useState(asset.value);
  const [accountType, setAccountType] = useState(asset.account_type);

  return (
    <>
      <Grid item xs={3}>
        <TextField
          value={accountType}
          fullWidth
          onChange={(e) => {
            setAccountType(e.target.value);
            asset.account_type = e.target.value;
            updateAssets();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField  
          value={notes}
          fullWidth
          onChange={(e) => {
            setNotes(e.target.value);
            asset.notes = e.target.value;
            updateAssets();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <MaskInput
          value={value}
          fullWidth
          mask_type="currency"
          onChange={(e) => {
            setValue(e.value);
            asset.value = e.value;
            updateAssets();
          }}
        />
      </Grid>
      <Grid item xs={1}>
        <DeleteButton
          iconStyle={{ marginLeft: '0', marginTop: '12px', display: 'flex', justifyContent: 'center' }}
          handleDelete={(d) => {
            asset.toDel = true;
            updateAssets();
            updateList();
          }} 
        />
      </Grid>
    </>
  );
};

function newAsset(asset_type, household_id) {
  return {
    asset_type,
    account_type: '',
    value: '',
    notes: '',
    new: true,
    household_id,
  };
}


const ClientAssets = (props) => {
  const { label, type, addAsset, updateAssets } = props;
  const [assets, setAssets] = useState(props.assets);
  let total = 0;
  assets.forEach((a) => {
    if (!a.toDel) {
      total += Number(a.value);
    }
  });

  function updateList() {
    const newAssets = [...assets];
    setAssets(newAssets);
  }

  return (
    <Grid container spacing={0.5} sx={{ marginTop: '10px', marginBottom: '10px' }}>
      <Box sx={{ 
        backgroundColor: '#1d428a', 
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        color: colors.white,
        textAlign: 'center', 
        p: 2,
        fontWeight: 'bold',
        fontSize: { xs: '1.1rem', md: '1.3rem' },
        width: '100%',
        padding: '5px',
      }}>
        {label}
      </Box>
      <Box sx={{
        backgroundColor: '#fff',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        color: colors.black,
        textAlign: 'center', 
        p: 2,
        fontWeight: 'bold',
        fontSize: { xs: '1.2rem', md: '1.5rem' },
        width: '100%',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
      }}>
        <Grid container spacing={0.5} sx={{ marginBottom: '10px' }}>
          {
            assets.length > 0 && (
              <>
                <Grid item xs={3}>
                  <Typography sx={{ fontWeight: 'bold', textAlign: 'left', }}>
                    Account Type
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontWeight: 'bold', textAlign: 'left', }}>
                    Location / Note
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontWeight: 'bold', textAlign: 'left', }}>
                    Amount
                  </Typography>
                </Grid>
                {assets.map((asset) => {
                  if (!asset.toDel) {
                    return (
                      <ClientAssetForm
                        asset={asset}
                        updateAssets={updateAssets}
                        updateList={updateList}
                      />
                    );
                  }
                  return '';
                })}
              </>
            )
          }
          <Grid item xs={12}>
            <div style={styles.totalContainer}>
              <div style={styles.totalLabel}>Total:</div>
              <div style={styles.totalValue}>$ {formatCurrency(total) || '0.00'}</div>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Grid item xs={12}>
        <Button 
          variant="contained" 
          color="primary"
          onClick={() => {
            const na = newAsset(type);
            setAssets([...assets, na ]);
            addAsset(na);
          }}
          style={styles.addButton}
        >
          Add
        </Button>
      </Grid>
    </Grid>
  );
};

export default ClientAssets;

